import type { FC } from 'react';

import { ColorShadeElement, getLinearGradient, ImageShadeElement } from './styles';
import type { ShadeElementProps } from './types';

export const ShadeElement: FC<ShadeElementProps> = ({ colorHexCode, colorImageSrc }) => {
  const colorHexCodes = colorHexCode?.split(',').filter((hexCode) => Boolean(hexCode));

  if (colorHexCodes && colorHexCodes.length > 0) {
    const background = colorHexCodes.length > 1 ? getLinearGradient(colorHexCodes) : (colorHexCodes[0] as string);
    const ownerState = { background };

    return <ColorShadeElement ownerState={ownerState} />;
  }

  // TODO: This should be preferred?
  if (colorImageSrc) {
    return (
      <ImageShadeElement
        src={colorImageSrc}
        alt=""
      />
    );
  }

  return null;
};
